const categories = [
  {
    key: 'home',
    label: '首页',
    url: '/',
    submenu: [],
  },
  {
    key: 'service',
    label: 'Hidream服务',
    submenu: [
      {
        key: 'advertising',
        label: '广告投放',
        icon: (
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-hidream-mguanggaotoufang-copy"></use>
          </svg>
        ),
        url: '/advertising',
      },
      {
        key: 'operation',
        label: '品牌孵化',
        icon: (
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-hidream-mdaiyunyingfuhua-copy"></use>
          </svg>
        ),
        url: '/operation',
      },
    ],
  },
  {
    key: 'google',
    label: 'Google',
    url: '/google',
    submenu: [],
  },
  {
    key: 'facebook',
    label: 'FaceBook',
    url: '/facebook',
    submenu: [],
  },
  {
    key: 'media',
    label: '媒体资讯',
    url: '/media',
    submenu: [],
  },
  {
    key: 'about',
    label: '关于我们',
    submenu: [
      {
        key: '/aboutus',
        label: '关于我们',
        icon: (
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-hidream-mtuandui-copy-copy"></use>
          </svg>
        ),
        url: '/aboutus',
      },
      {
        key: '/joinus',
        label: '加入我们',
        icon: (
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-hidream-mhezuoguanxi-xianxing-copy-copy"></use>
          </svg>
        ),
        url: '/joinus',
      },
    ],
  },
  {
    key: 'contactus',
    label: '联系我们',
    url: '/contactus',
    submenu: [],
  },
  // {
  //   key: 'activity',
  //   label: '春风惠企',
  //   url: '/activity',
  //   submenu: [],
  // },
];

export default categories;
